export default __webpack_public_path__ + "static/footer-min-04f120f7094c8e9c0f2996127dd1243c.png";